import { FC } from 'react';

import { Image } from '../Image';

export const LogosGroup: FC<LogosGroupBlok> = ({ logos = [] }) => (
  <div className="flex flex-wrap items-center justify-center gap-4">
    {logos.map((image) => (
      <div key={image.id} className="h-14 w-24 shrink-0">
        <Image
          alt={image.alt}
          className="bg-transparent"
          size={{
            sm: { span: 2, ratio: '3/2' },
          }}
          src={image.filename}
          unoptimized
        />
      </div>
    ))}
  </div>
);
